import { Dialog } from '@stashinvest/ui';
import { connect } from 'react-redux';

import { confirmDialog, cancelDialog } from 'stash/actions/dialog';

const mapStateToProps = (state) => ({
	...state.application.dialog,
});

const mapDispatchToProps = (dispatch) => ({
	onCancel: () => {
		dispatch(cancelDialog());
	},
	onConfirm: () => {
		dispatch(confirmDialog());
	},
});

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
	const { confirm, cancel } = stateProps;
	return {
		...stateProps,
		...ownProps,
		confirm: () => {
			confirm && confirm();
			dispatchProps.onConfirm();
		},
		cancel: () => {
			cancel && cancel();
			dispatchProps.onCancel();
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Dialog);
